<template>
  <div id="video_page">
    <div class="left_part">
      <div class="left_main">
        <div class="left_tabs" v-if="create_type">
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 1 }]" @click="changeTab(1)">文生视频
          </div>
          <div flex-center :class="['tab_item', { 'active': create_form.create_type == 2 }]" @click="changeTab(2)">图生视频
          </div>
        </div>
        <div class="tools_introduce">
          <img class="face_icon" src="./img/face.png" alt="">
          <div class="introduce_main">
            <div class="introduce_title">功能介绍</div>
            <div class="introduce_text">
              {{
                create_form.model_version == 'sora2' ? '将创意转化为动态超级逼真的视频' : '输入提示词或上传图片即可生成任何风格且超级逼真的视频'
              }}
            </div>
          </div>
        </div>
        <lingganTool
            ref="lingganref"
            :MD5_KEY="'a5848975f3ae4ecc3509e7cc40559890'"
            @createSame="createSame"
            @use_only="use_only"
            :show_list="['model','size','desc','duration','quality','img_urls']"
            :model_list="platform_list"
            :size_list="size_list_data"
            :duration_list="durationList2"
            :quality_list="clarityList1"
        ></lingganTool>

        <div class="form_wrap">
          <template v-if="create_form.create_type == 2">
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">上传图片</div>
            </div>
            <div class="load_err_tips">注意：不可上传真实带头像的人物图。会导致任务失败。</div>
            <div class="upload_wrap" v-loading="upImgloading" element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload class="img-uploader" :action="fileAPI + '/api/front/aivideo/upload/?soft=1'"
                         :show-file-list="false" :before-upload="beforeUpload" accept=".jpg,.png"
                         :on-success="handleUploadSuccess">
                <div class="upload_inner" flex-center v-if="userInfo.is_vip < 1 || !isLogin">

                  <template v-if="select_rec_img.img_url">
                    <img class="upload_img" :src="cdn_url_replace(tenImg)" alt="">
                    <i @click.stop="deleteImg" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
                <div class="upload_inner" flex-center v-else>
                  <template v-if="tenImg">
                    <img class="upload_img" :src="cdn_url_replace(tenImg)" alt="">
                    <i @click.stop="deleteImg" class="el-icon-delete"></i>
                  </template>
                  <template v-else>
                    <i class="el-icon-plus"></i>
                    <div class="upload_text"> 将图片拖到此处，或<span style="color: #5865f2;">点击上传</span><br>
                      只能上传jpg/png文件，且不超过10MB
                    </div>
                  </template>
                </div>
              </el-upload>
            </div>
          </template>
          <div>
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">描述你的视频场景
                <!-- <div :class="create_form.desc.trim().length?'tishici tishici_act':'tishici'" @click="showTishici">优化提示词</div> -->
              </div>
            </div>
            <div class="desc_box" id="only_desc">
              <el-input :input-style="{ minHeight: '31px' }" :rows="4"
                        v-model="create_form.desc" type="textarea"
                        placeholder="请输入创意描述，包含内容主体+动作/场景，一键生成视频"/>
              <div class="desc_box_bottom">
                <div class="bottom_left" bottom_left @click="showTishici">
                  <!-- <el-switch v-model="auto_spell"
                             active-value="1"
                             inactive-value="0"
                             active-color="#5865F2"
                             inactive-color="#ffffff2d"></el-switch> -->
                  <div><img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt="">
                    Ai优化提示词（免费）
                  </div>
                </div>
                <div class="cleat_desc_btn" @click="create_form.desc = ''">清空</div>
              </div>
            </div>
          </div>

          <div class="form_title">
            <div class="title_icon"></div>
            <div class="title_text">选择模型</div>
          </div>
          <div class="model_wrap">
            <div @click="selectModel(model, index)"
                 :class="['model_item', 'select_item',
                  { 'active': create_form.model_version == model.name2 }]" flex-center
                 v-for="(model, index) in platform_list">{{ model.name }}
              <div class="need_vip" v-if="model.need_vip">VIP
              </div>
            </div>
          </div>
          <!--          <div class="form_title" v-if="create_form.model_version=='sora2_pro'">-->
          <!--            <div class="title_icon"></div>-->
          <!--            <div class="title_text">版本</div>-->
          <!--          </div>-->
          <!--          <div class="model_wrap" v-if="create_form.model_version=='sora2_pro'">-->
          <!--            <div @click="choiceFrom('version1', model.type)"-->
          <!--                 :class="['model_item', 'select_item',-->
          <!--                 { 'active': create_form.mode == model.type }]" flex-center-->
          <!--                 v-for="(model, index) in version1">{{ model.name }}-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="form_title" v-if="create_form.model_version=='sora2_pro'">
            <div class="title_icon"></div>
            <div class="title_text">清晰度</div>
          </div>
          <div class="model_wrap" v-if="create_form.model_version=='sora2_pro'">
            <div @click="choiceFrom('is_hd', model.type)"
                 :class="['model_item',
                 'select_item',
                 (index==1&&create_form.is_hd==0&&create_form.seconds==25)? 'selectVersion' : '',
                 { 'active': create_form.is_hd == model.type },]" flex-center
                 v-for="(model, index) in clarityList1">{{ model.name }}
            </div>
          </div>

          <div class="form_title">
            <div class="title_icon"></div>
            <div class="title_text">生成时长</div>
          </div>
          <div class="model_wrap" v-if="create_form.model_version=='sora2'">
            <div @click="choiceFrom('duration', model.type)"
                 :class="['model_item',
                 'select_item',
                  { 'active': create_form.seconds == model.type }, ]" flex-center
                 v-for="(model, index) in durationList1">{{ model.name }}
            </div>
          </div>
          <div class="model_wrap" v-if="create_form.model_version=='sora2_pro'">
            <div @click="choiceFrom('duration', model.type)"
                 :class="['model_item',
                 'select_item',
                  (index==2&&create_form.is_hd==1)? 'selectVersion' : '',
                  { 'active': create_form.seconds == model.type }, ]" flex-center
                 v-for="(model, index) in durationList2">{{ model.name }}
            </div>
          </div>
          <div>
            <div class="form_title">
              <div class="title_icon"></div>
              <div class="title_text">视频比例</div>
            </div>
            <div class="video_size_list">
              <div :class="['sise_item',{'active':video_size==item.value}]"
                   v-for="(item,index) in size_list"
                   :key="item.value"
                   @click="choiceFrom('size',item)">
                <img :src="item.url" alt="" class="size_img">
                {{ item.name }}
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="newSubList">
        <div class="newSumit newSumitOthers" @click="clickSubmit">
          提交任务（消耗{{ jifen }}积分）
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
    <div class="main_part">
      <div class="top_tips">
        <span class="one">#</span><span class="two">创作中心</span><span
          class="three">请遵守中华人民共和国网络安全法，严禁生成涉及政治人物，色情、恐怖等不良内容，
          如有违规封号处理</span>
      </div>
      <div class="create_center" ref="scrollWrap" @scroll="testScroll">
        <!--样例开始-->
        <div class="message_list"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="SampleListDisabled"
             v-if="!isLogin || video_list.length == 0">
          <div class="list_item" v-for="(msg, index) in sampleSysList">
            <div class="item">
              <div class="item_touxiang">
                <img src="../components/img/side/sora_logo.gif" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      {{
                        create_form.model_version == 'sora2_pro' ?  'Sora2 Pro' : 'Sora 2'
                      }}
                    </div>
                    <template>
                      <div class="item_type">
                        示例
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">
                    <div @click="sample_btn('del')">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('noDown')">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div style="margin-left: 5px" @click="sample_btn('put')">
                      <i class="el-icon-position"></i> 推荐广场
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap"
                     @click.stop="handlePlay('play',index,msg)">
                  <div class="creating" v-if="msg.status === 1">
                    <template>
                      <img class="loading_gif" src="./img/loading-new.gif">
                      <div class="loading_text"><span>生成视频需要极大的计算量，请耐心等待...</span> <span
                          v-if="msg.progress > 10">{{
                          msg.progress
                        }}%</span></div>
                    </template>
                  </div>
                  <video controls controlslist="nodownload" v-else style="width: 665px;height: 400px"
                         :poster="cdn_url_replace(msg.cover_url)" preload="none"
                         v-loading="true" :src="cdn_url_replace(msg.video_url)"
                         @play="handlePlay('',index)"
                         :ref="`videoPlayer${index}`"></video>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(msg,index)" v-show="!msg.is_vote">
                      <img src="./img/zan1.png" class="zanImg"/> 赞一下
                    </div>
                    <div class="zanDetail" v-show="msg.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg"/> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ msg.votes }}个赞
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例结束-->

        <!--        <div class="message_list" v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="noMore || loading">-->
        <div class="message_list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-immediate="false"
             :infinite-scroll-disabled="noMore">
          <div class="list_item" v-for="(msg, index) in video_list">
            <div class="item">
              <div class="item_touxiang">
                <img src="../components/img/side/sora_logo.gif" class="avatar"/>
              </div>
              <div class="item_right">
                <div class="item_top">
                  <div class="top_left">
                    <div style="font-size: 14px">
                      <!--                      {{ create_form.model_version == 'sora2_pro' ? 'Sora2' : 'Sora' }}-->
                      {{
                        create_form.model_version == 'sora2_pro' ?'Sora2 Pro' : 'Sora 2'
                      }}
                    </div>
                    <template>
                      <div class="item_type">
                        {{ msg.img_url == "" ? '文生视频' : '图生视频' }}
                      </div>
                    </template>
                    <div class="item_time">{{ msg.add_time }}</div>
                  </div>
                  <div class="top_right">

                    <div style="margin-left: 5px" @click="deleteVideo(index, msg)">
                      <i class="el-icon-delete"></i>删除
                    </div>
                    <div style="margin-left: 5px" @click="downloadVideo( msg,index)">
                      <i class="el-icon-download" style="font-size: 14px;"></i>下载
                    </div>
                    <div v-if="msg.status == 2">
                      <div style="margin-left: 5px" v-if="msg.is_public == 0 || msg.is_public == null"
                           @click="recommend(msg.id, index)">
                        <i class="el-icon-position"></i> 推荐广场
                      </div>
                      <div style="margin-left: 5px" v-else>
                        <i class="el-icon-position"></i> 已推荐到广场
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg_text" v-if="msg.text_prompt_cn">{{ msg.text_prompt_cn }}</div>
                <template v-if="msg.text_prompt">
                  <div class="split_line"></div>
                  <div class="msg_text msg_desc">{{ msg.text_prompt }}</div>
                </template>
                <div class="video_wrap">
                  <div v-if="msg.status == 0">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 1">
                    <div class="creating">
                      <template v-if="msg.progress > 10">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>

                  <div v-if="msg.status == 2 && msg.local_video_url === null">
                    <div class="creating">
                      <template v-if="msg.progress != 0">
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="progress">正在为您生成··· {{ msg.progress }}%</div>
                      </template>
                      <template v-else>
                        <img class="loading_gif" src="./img/loading-new.gif">
                        <div class="loading_text">生成视频需要极大的计算量，请耐心等待...</div>
                      </template>
                    </div>
                  </div>
                  <div v-if="msg.status == 2 && msg.local_video_url !== null" class="success_shou">
                    <div class="success_shouVideo"
                         @click.stop="onVideoPlay('play',index,msg)">
                      <video role="application" controls
                             controlslist="nodownload"
                             :poster="msg.cover_url != null ? msg.cover_url : ''"
                             :preload="msg.cover_url != null ? 'none' : 'auto'" v-loading="true"
                             :src="msg.local_video_url"
                             :ref="`videoPlayers${index}`"
                             @play="onVideoPlay('',index)"></video>
                      <div v-if="msg.img_url != null || msg.img_url != ''" class="success_img"
                           :style="msg.img_url == null || msg.img_url == '' ? 'display:none;' : 'display:;'">
                        <!--                        <img :src="msg.img_url" @error="handleImageError(index)"  alt="" class="xianshi" >-->
                        <img :src="msg.img_url" alt="" class="xianshi">
                        <div class="success_imgdel">
                          <div style="display: flex;align-items: flex-end;">
                            <span
                                style="background: #5865f2a8;border-radius: 3px;margin:  2px;padding: 0 4px;color: white">原图</span>
                          </div>
                          <div style="display: flex;flex-direction: column;padding: 2px 2px 0 0 ;">
                            <i class="el-icon-close yichang" @click="msg.img_url = ''"></i>
                          </div>
                        </div>
                      </div>
                      <div :style="msg.img_url == null || msg.img_url == '' ? 'display:none;' : 'display:;'"
                           style="position: absolute;top: 2px;left: 0;">
                        <span
                            style="z-index: 10;  background: #5865f2a8;border-radius: 3px;margin: 2px;padding: 3px 4px;color: white">生成后</span>
                      </div>
                    </div>
                  </div>
                  <div class="error_video" v-loading="msg.regenLoading > 0"
                       v-if="(msg.status == 3) && (msg.retry_num < 3 && msg.is_retry == 0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <!--                    <div class="error_text">很遗憾，生成失败 !</div>-->
                    <div class="error_text2" @click="regenerate(msg, index)">点此重新生成</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4" v-if="msg.show_error">
                      失败原因： <span style="color:red;">{{ msg.show_error }}</span>
                    </div>
                    <div class="error_text4" v-else>
                      <span>涉政、涉黄等请勿提交，会封号其他问题，请联系</span>
                      <a
                          :href="kefu_url"
                          target="_blank">在线客服</a>
                    </div>
                  </div>
                  <div class="error_video create_error_old"
                       v-else-if="(msg.status == 3) && (msg.retry_num >= 3 || msg.is_retry != 0)">
                    <!-- 绘画 失败 -->
                    <img class="error_icon" src="./img/image_error.png" alt="">
                    <div class="error_text">很遗憾，生成失败 !</div>
                    <div class="error_btn" @click="showDefeatPopup()">查看失败原因</div>
                    <div class="error_text3">（成功率在90%以上）</div>
                    <div class="error_text4">涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                        :href="kefu_url"
                        target="_blank">在线客服</a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <shibaiyuanyin ref="retryPop"></shibaiyuanyin>

    <!-- ai提示词 -->
    <AIpromptWords
        :typedata="'Runway Gen3a_turbo、Runway Gen'"
        :inpdata="create_form.desc"
        @getPromptData1="getPromptData2"
        ref="promptBox"/>
  </div>

</template>
<script type="text/ecmascript-6">

import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import shibaiyuanyin from "COMPONENTS/shibaiyuanyin.vue";
import AIpromptWords from "COMPONENTS/AIpromptWords.vue";
import lingganTool from "COMPONENTS/lingganTool.vue";
import utils from '../../utils'
import AliCdn from '../../utils/ali_cdn'

export default {
  components: {faceVerifyPopup, shibaiyuanyin, AIpromptWords, lingganTool},
  data() {
    return {
      kefu_url: SITE_BTN_CONFIG.kefu_url.btn_value,
      promptList1: [
        {
          ch: "电影级10秒保时捷911 Turbo S广告，展现风与自由的终极表达。一位30多岁的中国男性驾驶者，英俊自信，摇下车窗，狂风掀起他乌黑的发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际，夕阳将天空染成橙红色。开篇特写驾驶员陶醉的面部表情，戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹，慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑。8K超清画质，ARRI Alexa拍摄，电影级调色，超现实主义质感。广告词使用中文表达，传递纯粹、野性的愉悦与解放感。 ",
          en: `A cinematic 10-second Porsche 911 Turbo S commercial, showcasing the ultimate expression of wind and freedom. A handsome, confident Chinese male driver in his 30s rolls down his window, with the wind tossing his jet-black hair as a relaxed, euphoric smile graces his face. The scene unfolds along a coastal cliff road at golden hour, with a deep blue horizon stretching into the sky, and the setting sun painting the sky in hues of orange-red. The opening close-up captures the driver's entranced expression, followed by a dramatic crane shot revealing the Porsche carving sharp lines through the winding road. Slow-motion footage captures the car's graceful cornering, with sunlight dancing in shimmering patterns across its perfect paintwork. Shot in 8K ultra-high definition with an ARRI Alexa camera, the commercial features cinematic color grading and a surrealist texture. The Chinese text slogan conveys pure, untamed joy and liberation.`
        }, {
          ch: "真人拍摄，现代都市异能短剧《战神觉醒》，暴雨中的摩天楼顶场景，主角（身高188cm穿着残破西装）站在天台边缘，闪电照亮他染血的侧脸。突然西装爆裂露出背后龙纹刺青，雨水在距离身体10cm处自动蒸发。采用360度环绕镜头，画面交替特写刺青觉醒过程与楼下跪拜的黑衣人群。冷蓝色调中穿插金色能量光效，暴雨声渐弱转为心跳声，当刺青完全亮起时，所有黑衣人齐声呐喊'三年之约已到，恭迎战神归来！'（中文台词带混响效果） ",
          en: `In the live action shooting, the modern urban power short play "Ares Awakening", the scene of the skyscraper roof in the rainstorm, the main character (188cm tall and wearing a torn suit) stands at the edge of the roof, and the lightning illuminates his bloody side face. Suddenly, the suit burst, revealing the dragon tattoo on the back, and rainwater evaporated automatically at a distance of 10cm from the body. Using a 360 degree surround camera, the image alternates between close-up shots of the tattoo awakening process and the black clad crowd kneeling downstairs. The cold blue color is interspersed with golden energy light effect, and the sound of rainstorm gradually turns into heartbeat. When the tattoo is fully lit, all the people in black shout in unison, 'The three-year appointment has arrived, and welcome the return of God of War! (Chinese dialogue with reverberation effect)`
        },
        {
          ch: "10秒电影级保时捷911 Turbo S电视广告文案‌（终极风与自由的表达） ‌画面‌：一位30多岁英俊自信的男性驾驶者摇下车窗，任由狂风掀起发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际。‌镜头语言‌：开篇特写驾驶员陶醉的面部表情戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑+技术参数‌：+ 8K超清画质｜ARRI Alexa拍摄｜电影级调色｜超现实主义质感 +‌内核‌：纯粹、野性的愉悦与解放感",
          en: `10-second Porsche 911 Turbo S TV commercial copy (the ultimate expression of wind and freedom) Picture: A handsome and confident man in his thirties, the driver, rolls down the car window, letting the wind tousle his hair, with a relaxed and ecstatic smile on his face. The scene is set on a coastal cliff road at golden hour, with the deep blue sea stretching towards the horizon. Cinematography: The opening shot is a close-up of the driver's intoxicated facial expression. The camera then pulls back dramatically to show the Porsche carving a sharp trajectory on the winding road. Slow-motion captures the light spots dancing on the perfect paint job as the vehicle elegantly takes the corner, bathed in sunlight. Technical parameters: 8K ultra-high-definition | shot with ARRI Alexa | film-grade color grading | surrealistic texture. Core: pure, wild pleasure and liberation.`
        },
        {
          ch: "白色洞洞鞋广告宣传视频，国际超模，时尚大片",
          en: `White Hole Hole Shoe Ad Prop Video, International Super Model, Fashion Big Hit`
        },
        {
          ch: "电影级实感丰田AE86电视广告‌画面‌：AE86在雨夜山道上华丽漂移，霓虹都市在背景中铺展如光之画卷。高速动态捕捉，车身倒映斑斓光影，黑色电影风格打光，致敬《头文字D》电影美学。核心元素‌：湿滑路面与轮胎摩擦的蒸汽特效车灯划破雨幕的丁达尔效应仪表盘红光与冷调环境光的赛博对比技术规格‌：4K HDR｜120fps升格拍摄｜胶片颗粒质感｜杜比全景声混音风格参考‌：《银翼杀手2049》×《头文字D》终极融合",
          en: `Toyota AE86 TV commercial with cinematic realism: AE86 performs a spectacular drift on a mountain road in the rain at night, with the neon-lit cityscape unfolding in the background like a canvas of light. High-speed dynamic capture shows the car's body reflecting a riot of colors and light. The black film style lighting pays homage to the aesthetic of the "Initial D" movie. Key elements: steam effects from the wet road and tire friction, Tyndall effect of the headlights piercing the rain curtain, and the cyber contrast of the red dashboard lights against the cool ambient light. Technical specifications: 4K HDR | 120fps slow-motion shooting | film grain texture | Dolby Atmos surround sound. Style references: "Blade Runner 2049" x "Initial D" ultimate fusion.`
        },
        {
          ch: "山姆·奥尔特曼穿着相声长袍说报菜名，内容如下：蒸羊羔、蒸熊掌、蒸鹿尾儿、烧花鸭、烧雏鸡、烧子鹅、炉猪、炉鸭、酱鸡、腊肉、松花、小肚儿、晾肉、香肠儿。什锦苏盘儿、熏鸡白肚儿、清蒸八宝猪、江米酿鸭子。罐儿野鸡、罐儿鹌鹑、卤什件儿、卤子鹅、山鸡、兔脯、菜蟒、银鱼、清蒸哈什蚂。烩腰丝、烩鸭腰、烩鸭条、清拌鸭丝儿、黄心管儿、焖白鳝、焖黄鳝、豆豉鲇鱼、锅烧鲤鱼、锅烧鲶鱼、清蒸甲鱼、抓炒鲤鱼、抓炒对虾、软炸里脊、软炸鸡。什锦套肠儿、麻酥油卷儿、卤煮寒鸦儿、熘鲜蘑、熘鱼脯、熘鱼肚、熘鱼骨、熘鱼片儿、醋熘肉片儿。烩三鲜儿、烩白蘑、烩全饤儿、烩鸽子蛋、炒虾仁儿、烩虾仁儿、烩腰",
          en: `Sam Altman, dressed in a traditional Chinese opera costume, recited a list of dishes as follows: steamed lamb, steamed bear paws, steamed deer tails, roast duck, roast chicken, roast goose, roast pork, roast duck, braised chicken, cured meat, smoked duck, sausages, small intestine, dried meat, sausages. Assorted cold dishes, smoked chicken and white duck, steamed eight-treasure pork, glutinous rice-stuffed duck. Wild chicken in a jar, quail in a jar, assorted braised dishes, braised goose, pheasant, rabbit breast, vegetable snake, silver fish, steamed turtle. Stewed shredded kidney, stewed duck kidneys, stewed duck strips, cold mixed duck fillets, yellow heart tubes, braised white eel, braised yellow eel, black bean sauce catfish, pan-fried carp, pan-fried catfish, steamed turtle, stir-fried carp, stir-fried prawns, soft-fried pork fillet, soft-fried chicken. Assorted stuffed intestines, sesame oil rolls, braised jackdaws, sautéed fresh mushrooms, sautéed fish fillets, sautéed fish maws, sautéed fish bones, sautéed fish slices, vinegar sautéed pork slices. Stewed three delicacies, stewed white mushrooms, stewed assorted dishes, stewed pigeon eggs, stir-fried shrimp, stewed shrimp, stewed kidneys.`,
        },
        {
          ch: "山姆·奥尔特曼你说说为什么不给安卓上架个sora app，普通话说",
          en: `Sam Altman, tell me why you don't put a Sora app on Android. Speak in Mandarin`
        },
        {
          ch: "山姆·奥尔特曼用中文讲相声，不用自我介绍，直接讲段子",
          en: `Sam Altman performs cross talk in Chinese, without the need for self-introduction, directly delivering jokes`
        },
        {
          ch: "我的AirPod Pro充电盒晃动了一下，然后四肢和机械头突然弹出，接着它站起来走掉了。",
          en: `My AirPod Pro charging case shook briefly, and then its limbs and mechanical head suddenly popped out. After that, it stood up and walked away.`
        },
        {
          ch: "小猫泡澡，香香水果薄荷浴",
          en: `A cat is bathing in a pool of warm, refreshing water with a sprinkle of mint and a squeeze of fresh fruits.`
        },
        {
          ch: "坐在月球上的咖啡馆里。这是一间温馨而极简的咖啡馆，暖色调的灯光。手边只有一杯咖啡和一台笔记本电脑。窗外是地球。山姆转向镜头说：‘这里的Wi-Fi得升级一下’。",
          en: `Sitting in a café on the moon. This is a cozy and minimalist café, with warm-toned lighting. All I have at hand is a cup of coffee and a laptop. Outside the window is Earth. Sam turns to the camera and says, 'The Wi-Fi here needs an upgrade.'`
        },
      ],
      scoreCode: 25,
      create_form: {
        create_type: 1,
        img_url: "",//普通
        desc: "",
        auto_optimize: false,
        style: 0,
        size: '1:1',
        duration: 10, // 修改默认时长为 10秒
        soft: 1,
        aspect_ratio: 6,
        mode: 'sora2',
        img_urls: "",//以图片作为结尾帧
        seconds: 10,// 默认视频时长
        exploreMode: false, //true探索模式 false积分模式
        is_hd: 0, // 清晰度  1 高清 0 标清
        model_version: 'sora2',
      },
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      tenImg: '',
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      platform_list: [

        {name: "Sora2", name2: "sora2", need_vip: 1, desc: 'Runway Gen 3 影视级动画特效，生成效果较好', platform: 1},
        {
          name: "Sora2 Pro",
          name2: "sora2_pro",
          need_vip: 1,
          desc: '即将开放OpenAI-Sora大师级模型，长达60秒巨作',
          platform: 3
        },
      ],
      clarityList1: [
        {name: '标清', type: '0',},
        {name: '高清', type: '1',},
      ],
      durationList1: [
        {name: '10秒', type: '10', value: 10},
        {name: '15秒', type: '15', value: 15},
      ],
      durationList2: [
        {name: '10秒', type: '10', value: 10},
        {name: '15秒', type: '15', value: 15},
        {name: '25秒', type: '25', value: 25},
      ],
      video_list: [],
      noMore: true,
      testnoMore: false,
      page: 1,
      intervalId: null,
      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      tenCurent: 0,
      tagAvt: 1,

      upImgloading: false,
      zanID: 0,
      isZan: false,
      votes: 0,
      auto_spell: '1',
      perIncan: false, // ai提示词是否返回
      newscoreCode: 35,
      isTips: false,
      SampleListDisabled: true,
      size_list: [
        {name: '16:9', value: '16:9', url: require('./img/16^9.png')},
        {name: '9:16', value: '9:16', url: require('./img/9^16.png')},
      ],
      size_list_data: [
        {name: '16:9', value: '16:9'},
        {name: '9:16', value: '9:16'},
      ],
      video_size: '16:9',
      jifen: 10,
      // 版本选择
      is_version: 'sora2',
      // 版本信息
      version1: [
        {name: 'Sora2', type: 'sora2',},
        {name: 'Sora2 Pro', type: 'sora2_pro',},
      ],
    }

  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    create_type() {
      this.create_form.create_type = this.$store.state.video_type || 1;
      return this.$store.state.video_type || 1;
    },
  },
  created() {
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserVideoList') || "[]")
    this.fetchVideoList()
    // this.fettchSampleList()
    this.handleSample()
    this.debouncedFetchData = this.debounce((data) => this.checkZan(data), 300)
    this.debouncedOutData = this.debounce((data) => this.outZan(data), 300)
    // 页面初始化时自动拼接默认比例到描述词
    // this.initDefaultRatio();
  },
  mounted() {
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null
    }

  },
  methods: {
    use_only(data) {
      if (data.data.img_url) {
        this.changeTab(2)
      }else{
        this.changeTab(2)
      }
      if (data.type == 'duration') {
        if(!this.create_form.is_hd){
          this.create_form.seconds = data.data.duration
        }
      } else if (data.type == 'desc') {
        this.create_form.desc = data.data.desc
      } else if (data.type == 'size') {
        this.create_form.model_version = data.data.model
        this.video_size = data.data.size
        if(data.data.size == '21:9'||data.data.size == '9:21'){
          // this.create_form.is_hd = 1
          this.choiceFrom('is_hd',1)
        }
      } else if (data.type == 'model') {
        this.create_form.model_version = data.data.model
      } else if (data.type == 'quality') {
        if(this.create_form.seconds != 25){
          this.create_form.is_hd = data.data.quality
        }
      }
      this.handleJf()
    },
    // 创建同款
    createSame(data) {
      console.log(data);
      if (data.img_url) {
        this.changeTab(2)
      } else {
        this.changeTab(1)
      }
      this.create_form.desc = data.desc
      this.video_size = data.size
      this.create_form.model_version = data.model
      this.create_form.seconds = data.duration
      this.create_form.is_hd = data.quality
      if(data.size == '21:9'||data.size == '9:21'){
        this.choiceFrom('is_hd',1)
      }else{
        this.choiceFrom('is_hd',0)
      }
      if (data.img_url) {
        this.create_form.img_urls = data.img_url
        this.create_form.img_url = data.img_url
        this.select_rec_img.img_url = data.img_url
        this.tenImg = data.img_url
      }
      this.create_form.id = data.id
      this.create_form.md5_key = utils.setMd5Key(data.id)
      this.handleJf()
    },
    cdn_url_replace(url, o_url, c_url) {
      if (!url) {
        return
      }
      if (!c_url) {
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url) {
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1) {
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      if (url.indexOf('https://zjzai20251109.oss-cn-hangzhou.aliyuncs.com') > -1) {
        return AliCdn.signUrl(url, {
          cdnDomain: "cdnzjzai.m.nengshuohuihua.com"
        })
      }
      return url.replace(o_url, c_url)
    },
    // 初始化默认比例
    initDefaultRatio() {
      const ratioText = `--生成比例 ${this.video_size}`;
      if (!this.create_form.desc.includes('--生成比例')) {
        this.create_form.desc = ratioText;
      }
    },
    handleSample() {
      console.log('进入样例')
      this.promptList1.forEach((e, i) => {
        this.sampleSysList.push({
          tempListobj: 1,
          add_time: utils.getRandomTimeToday(),
          again_prompt: "",
          ctype: 2,
          data_json: {
            cover_image_urls: [`https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.create_form.model_version == 'sora2' ? '2' : '1'}/${i + 1}.1.mp4`,],
            image_urls: [`https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.create_form.model_version == 'sora2' ? '2' : '1'}/${i + 1}.1.mp4`,]
          },
          down_status: 1,
          down_time: utils.getRandomTimeToday(),
          id: 950,
          cover_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.create_form.model_version == 'sora2' ? '2' : '1'}/${i + 1}.2.webp`,
          video_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.create_form.model_version == 'sora2' ? '2' : '1'}/${i + 1}.1.mp4`,
          output_url: `https://faceswap8.oss-cn-beijing.aliyuncs.com/sora/example/sample/promptList${this.create_form.model_version == 'sora2' ? '2' : '1'}/${i + 1}.2.webp`,
          text_prompt: e.en,
          text_prompt_cn: e.ch,
          status: 2,
          template_id: 0,
        })
      })

      // if (this.creadExample1.length != 0) {
      //   this.tempListobj.unshift(...this.creadExample1)
      // }
      console.log('this.tempListobj')
      // this.myList = this.tempListobj
      // this.StatusExample()
      // this.tempListShow = true
    },
    // selectSize(item) {
    //   this.video_size = item.name
    // },
    testScroll() {
      utils.setScrollDoc()
      const create_center = document.querySelector('.create_center')
      if (create_center.scrollTop + create_center.clientHeight >= create_center.scrollHeight) {
        if (!this.testnoMore) {
          this.$message.warning('已加载全部样例！')
          this.testnoMore = true
        }
      }
    },
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    setScore() {
      if (this.create_form.create_type == 1) {
        console.log('文生视频')
        if (this.create_form.seconds == 5 && this.create_form.is_hd == 0) {
          this.scoreCode = 25
          this.newscoreCode = 35
        } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
          this.scoreCode = 50
          this.newscoreCode = 70
        } else if (this.create_form.seconds == 5 && this.create_form.is_hd == 1) {
          this.newscoreCode = 35
        } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 1) {
          this.newscoreCode = 70
        }
      } else {
        // console.log('图省事视频')
        if (!this.create_form.img_urls) {
          if (this.create_form.seconds == 5 && this.create_form.is_hd == 0) {
            this.scoreCode = 25
            this.newscoreCode = 35
          } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
            this.scoreCode = 50
            this.newscoreCode = 70
          } else if (this.create_form.seconds == 5 && this.create_form.is_hd == 1) {
            this.newscoreCode = 35
          } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 1) {
            this.newscoreCode = 70
          }
        } else {
          this.scoreCode = 50
        }

      }

    },
    changeTab(data) {
      this.create_form.create_type = data
      this.create_form.is_hd = 0
      this.choiceFrom('is_hd', 0)

      if (data == 1) {
        this.create_form.img_urls = ''
        this.select_rec_img.img_url = ''
      }
    },
    deleteImg() {
      if (this.tagAvt == 2) {
        this.definition = [{name: '标清', value: 0}, {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        this.create_form.img_url = ''
      }
      this.tenImg = ''
      this.select_rec_img.img_url = ''
    },

    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    fettchSampleList() {
      this.SampleListDisabled = true
      // 获取样例数据
      this.$http.get('/front/aivideo/sample/?soft=8', {
        params: {
          page: this.page,
          size: 5,
        }
      }).then((res) => {
        this.page++
        this.SampleListDisabled = false
        if (res.data.item_list.length < 5) {
          this.SampleListDisabled = true
        }
        this.sampleSysList = this.sampleSysList.concat(res.data.item_list)
        this.sampleSelectList = res.data.item_list
      })
    },

    fetchVideoList() {
      this.$http.get(`/front/aivideo/user/video/`, {
        params: {
          max_mj_id: this.max_mj_id,
          soft: 8,
          model_version: this.create_form.model_version
        }
      }).then(res => {
        if (res.status == '200') {
          this.noMore = false
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {
                if (e.status <= 1 || (e.status == 2 && !e.local_video_url)) {
                  this.checkIds.push(e.id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].id
            this.video_list = this.video_list.concat(res.data.item_list)

            this.video_list.forEach(item => {
              item.img_url.length == 0 ? item.img_url = '' : item.img_url
              if (item.regenLoading != 1) {
                item.regenLoading = 0
              }
            })


          } else {
            this.noMore = true
            if (this.max_mj_id == 0) {
              // this.fettchSampleList()
            }
          }
        } else {
          // this.fettchSampleList()
        }
      }).finally(() => {

      })
    },
    fetchMsg() {
      if (this.checkIds.length === 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      this.timer = setInterval(() => {
        this.$http.post('/front/aivideo/check/', {ids: this.checkIds}).then((res) => {
          if (res.status === "200") {
            let item_list = res.data.item_list;
            let _id = 0;
            item_list.forEach(e => {
              _id = e.id

              if (e.status == 3 && e.error_message == '服务异常,请联系客服') {
                this.$confirm("服务异常,请联系客服", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })

              } else if (e.status == 3 && e.error_message == '任务提交失败，请重试！') {
                this.$confirm("生成异常，已为您重新排队", '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                }).catch(() => {

                });
                this.create_form.desc = e.text_prompt_cn
                this.create_form.img_url = e.img_url
                this.create_form.model_version = e.mode
                this.create_form.seconds = e.seconds
                this.create_form.style = e.style
                this.create_form.duration = e.seconds
                // this.create_form.exploreMode = e.exploreMode== 1? true:false

                this.checkIds = this.checkIds.filter(i => i !== _id)
                this.video_list.forEach((item, index,) => {
                  if (item.id == _id) {
                    item.status = 3
                  }
                })
                this.clickSubmit()
              } else if (e.status == 3 && e.show_error_message) {
                this.$message.error(e.error_message)
              }

              let item = this.video_list.filter((obj) => obj.id === _id)[0];
              item.text_prompt = e.text_prompt
              item.text_prompt_cn = e.text_prompt_cn
              item.status = e.status
              item.is_public = 0
              item.img_url = e.img_url
              // item.progress = e.progress
              let num = parseInt(Math.random() * 10);
              if (item.progress + num > 100) {
                item.progress = 99
              } else {
                item.progress += num
              }
              if (e.status > 2) {
                // 删除生成成功或失败的
                this.checkIds = this.checkIds.filter(i => i !== _id)

              }
              if (e.status == 2 && e.local_video_url != null) {
                // 生成成功 并下载本地
                this.checkIds = this.checkIds.filter(i => i !== _id)
                // 生成成功 并下载本地
                item.local_video_url = e.local_video_url
                item.cover_url = e.cover_url
                item.img_url = e.img_url
                item.text_prompt = e.text_prompt
                item.regenLoading = 0
                item.progress = 100
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status === 3) {
                // 失败
                item.show_error = e.show_error
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.video_list.forEach((_list, num) => {
                  if (_list.id == e.id) {
                    this.video_list[num] = e
                  }
                })
              }
            })
          }
          if (this.checkIds.length === 0) {
            clearInterval(this.timer);
          } else {
            clearInterval(this.timer);
            this.fetchMsg()
          }
        }).catch((res) => {
          clearInterval(this.timer);
        })
      }, 5000)
    },
    showTishici() {
      if (this.$refs.lingganref) {
        this.$refs.lingganref.visible = false
        this.$refs.lingganref.show_detail_popup = false
      }
      if (document.querySelector('.autoMatic_box')) {
        this.$refs.promptBox.show(false)
      } else {
        if (!this.isLogin) {
          this.$message.warning('请先登录！')
          return
        }
        if (!this.create_form.desc.trim().length) {
          this.$message.warning('请输入创意描述！')
          return
        }
        this.$refs.promptBox.show(true)
      }
    },
    clickSubmit() {

      if (!this.checkLogin()) {
        return
      }
      if (SITE_BTN_CONFIG.btn_sora_create.btn_state == 0) {
        if (this.userInfo.is_vip == 0) {
          utils.createErrTip('no_open_vip')
        } else {
          if (this.userInfo.is_vip_end == 1) {
            utils.createErrTip('vip_expire')
          } else {
            this.$store.commit('setTechnical_Show', true)
          }
        }
        return;
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      if (this.create_form.desc.trim() == "") {
        this.$message.warning('请输入描述')
        return false
      }
      if (this.create_form.desc.trim().length > 500) {
        this.$message.warning('描述信息不能超过500字符')
        return
      }
      if (this.create_form.create_type == 2) {
        if (this.create_form.img_url == '') {
          this.$message.warning('请上传图片')
          return false
        }
      }

      // 在提交前拼接比例到描述词
      const ratioText = `--生成比例 ${this.video_size}`;
      let desc = this.create_form.desc;

      // 移除旧的比例描述（如果存在）
      desc = desc.replace(/--生成比例\s+\d+:\d+/g, '').trim();
      // 拼接新的比例描述
      this.create_form.desc = desc ? `${desc} ${ratioText}` : ratioText;
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc


      if (this.create_form.create_type === 1) {
        this.create_form.img_url = ""
      }
      if (this.sendLoading) {
        this.$message.warning('正在提交任务！')
        return
      }
      // if (this.auto_spell > 0) {
      //   console.log('ai提示词')
      //   if (!this.perIncan) {
      //     this.$refs.promptBox.show(true)
      //     return;
      //   }
      // }
      // 修复：应该让 duration 跟随 seconds，而不是反过来
      this.create_form.duration = this.create_form.seconds
      this.create_form.is_optimize = this.create_form.auto_optimize
      this.sendLoading = true
      this.create_form.soft = 8
      this.create_form.size = this.video_size
      this.create_form.mode = this.create_form.model_version


      this.getPromptData3()
      console.log('this.create_form', this.create_form)
      // return
      if (this.create_form.md5_key) {
        this.$http.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/`, {
          params: {
            id: this.create_form.id,
            md5_key: this.create_form.md5_key
          }
        }).then(res => {
          this.create_fun(this.create_form)
        })
      } else {
        this.create_fun(this.create_form)
      }

    },
    create_fun(data) {
      this.$http.post('/front/aivideo/', data).then(res => {

        if (res.status === '200') {
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          this.getProfile()
          this.create_form.img_url = ''
          this.select_rec_img.img_url = ''
          this.create_form.img_urls = ''
          this.tenImg = ''
          this.create_form.desc = "";
          let video = res.data.video
          this.create_form.is_hd = 0
          this.isTips = false
          video.progress = 0
          this.video_list.unshift(video);
          //this.scrollToTop();
          this.checkIds.push(video.id)
          this.fetchMsg()
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    handleUploadSuccess(response, uploadFile) {
      this.upImgloading = false
      if (response.data.error !== '') {
        this.$message.error(response.data.error)
        return
      }
      if (response.status == '200') {
        if (this.tagAvt == 2) {
          this.definition = [{name: '高清', value: 0},]
          this.create_form.is_hd = 0
          this.select_rec_img.img_urls = response.data.file_full_url
          this.create_form.img_urls = response.data.file_full_url
          this.setScore()
        } else {
          this.create_form.img_url = response.data.file_full_url
          this.select_rec_img.img_url = response.data.file_full_url
        }
        this.tenImg = response.data.file_full_url
      }
    },
    beforeUpload(rawFile) {
      const isIMG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png';
      const isLt10M = rawFile.size / 1024 / 1024 < 10;
      const isSole = true
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(rawFile);
        img.onload = () => {
          let wS = img.width / img.height
          let hS = img.height / img.width
          if (!isIMG) {
            reject({isIMG: false})
            this.$message.error('上传图片只能是 JPG/PNG 格式!');
            return
          }
          if (!isLt10M) {
            reject({isLt10M: false})
            this.$message.error('上传图片大小不能超过 10MB!');
            return
          }
          // if ((wS >= 0.4 && wS <= 2.5) || (hS >= 0.4 && hS <= 2.5)) {
          //   if (img.width <= 500 || img.height <= 500) {
          //     reject({isSole: false})
          //     // this.$message.error('图片大小需要大于500小于4090');
          //     this.$message({
          //       message: '图片大小需要大于500小于4090',
          //       type: 'warning'
          //     })
          //     return false
          //   }
          //   if (img.width >= 4090 || img.height >= 4090) {
          //     reject({isSole: false})
          //     // this.$message.error('图片大小需要大于500小于4090');
          //     this.$message({
          //       message: '图片大小需要大于500小于4090',
          //       type: 'warning'
          //     })
          //     return false
          //   }
          // } else {
          //   reject({isSole: false})
          //   this.$message({
          //     message: '图片宽高比需在5:2或2:5之内',
          //     type: 'warning'
          //   })
          //   return false
          // }
          this.upImgloading = true
          resolve({isIMG, isLt10M, isSole});
        }
      })
    },
    selectTimer(data) {
      this.create_form.duration = data.value
      if (data.value == 5) {
        if (this.create_form.img_urls) {
          this.setScore()
          return
        }
        this.setScore()
      } else if (data.value == 10) {
        this.setScore()
      }
      console.log(this.create_form)
    },
    selectModel(model, index) {
      if (this.create_form.model_version == model.name2) return
      this.create_form.is_hd = 0
      // this.choiceFrom('is_hd', 0)
      this.create_form.seconds = 10
      this.create_form.mode = 'sora2'
      this.create_form.model_version = model.name2
      this.max_mj_id = 0
      this.video_list = []
      this.fetchVideoList()
      this.sampleSysList = []
      if (this.create_form.model_version == 'sora2') {
        this.promptList1 = [
          {
            ch: "音乐MV，城市流行。少女唱着中文流行歌曲，乘坐出租车眺望窗外，窗外下着雨，夜晚的街道飞驰而过。",
            en: `Music MV, urban pop. The girl sang Chinese pop songs, took a taxi and looked out the window. It was raining outside, and the streets were speeding by at night.`
          },
          {
            ch: "深夜的极简主义工作台上，一个AirPod Pro充电盒突然高频震动，金属外壳如花瓣般优雅展开，精密齿轮与液压杆协同运作，瞬间组装成1.2米高的类人机器人。机械体采用钛合金骨架与半透明聚合物外壳，内部电路发出幽蓝脉冲光。机器人以猫科动物般的敏捷跃下桌面，在冷调月光与霓虹灯带交织的实验室穿行，经过全息投影界面时触发数据流涟漪。镜头采用Steadicam稳定器跟拍，配合0.5倍速子弹时间特效，突出机械关节的液压运作细节与碳纤维肌腱的伸缩。主光源为2700K色温的隐藏式射灯，在抛光金属表面形成动态高光，环境光采用HDR渲染的赛博朋克青橙色调。",
            en: `On the minimalist workbench in the late night, an AirPod Pro charging case suddenly vibrates at high frequency, and the metal shell elegantly unfolds like a flower petal. Precise gears and hydraulic rods work together to instantly assemble into a 1.2-meter-high humanoid robot. The mechanical body adopts a titanium alloy skeleton and a semi transparent polymer shell, and the internal circuit emits a faint blue pulse light. The robot jumps off the desktop with feline like agility, navigating through a laboratory interwoven with cool moonlight and neon lights, triggering ripples in the data stream as it passes through the holographic projection interface. The camera adopts Steadicam stabilizer for follow-up shooting, combined with 0.5x bullet time effect, highlighting the hydraulic operation details of mechanical joints and the extension and contraction of carbon fiber tendons. The main light source is a hidden spotlight with a color temperature of 2700K, which creates dynamic highlights on the polished metal surface. The ambient light is rendered in HDR cyberpunk green orange tones.`
          }, {
            ch: "中国女主播在珠穆朗玛峰大本营，身着最新款高科技羽绒服面对手机镜头直播。她一边展示服装的防风防水功能，一边与观众互动。背景可见登山队员和帐篷，镜头在主播近景和雪山全景间切换。夕阳的余晖为画面镀上金色，整体氛围既专业又充满极限挑战的刺激感。",
            en: `Chinese female anchor, dressed in the latest high-tech down jacket, is live streaming in front of the phone camera at the Everest base camp. She demonstrated the windproof and waterproof functions of the clothing while interacting with the audience. The background shows mountaineers and tents, and the camera switches between the anchor's close-up and the panoramic view of the snow capped mountains. The afterglow of the sunset paints the picture with gold, creating a professional and thrilling atmosphere full of extreme challenges.`
          },
          {
            ch: "4只猫在打麻将，忽然打了起来",
            en: `Four cats are playing mahjong, and then one of them starts to play.`
          },
          {
            ch: "穿越回17世纪，和牛顿在伦敦的一家古老酒吧里聊天。历史上的牛顿，不仅发现了地心引力，还和我开起了玩笑。",
            en: `In the 17th century, I met Newton at an old bar in London. Newton not only discovered the theory of gravity, but also had a good time with me.`
          },
          {
            ch: "换成蚂蚁爬在草丛中找吃的",
            en: `A ant is crawling in a field, looking for food.`
          },
          {
            ch: "人类vs动物。Sora 2逼真度全面展示，每个动作和机位都像真实拍摄。",
            en: `Human vs. animal. Sora 2 showcases its realistic degree comprehensively, with each action and shot looking like a real shot.`
          },
          {
            ch: "小猫理发师在给中国男人理发，手滑把头发理成了秃子，中国男人气愤地追小猫理发师",
            en: `A cat barber is giving a man in China a haircut, but he accidently scrunched the hair into a ponytail. The man is angry at the cat barber.`
          },
          {
            ch: "一位美得令人窒息、五官优雅的女子，在金色时节，站在樱花雨下，长发被风轻轻扬起。她接住一片飘落的花瓣，轻轻一笑，凝视着眼前男子的双眼——爱意在她眼中闪耀。",
            en: `A beautiful woman, with graceful features and long hair, is standing in the golden season, under a sakura rain. Her long hair is lightly blown by the wind. She catches a falling petal, smiles, and gazes at the eyes of the man in front of her — the love is shining in her eyes.`
          },
          {
            ch: "音乐MV，城市流行。少女乘坐出租车眺望窗外，窗外下着雨，夜晚的街道飞驰而过。",
            en: `A music MV, city-pop. A beautiful girl is driving a taxi to look at the window outside. The window is covered with rain, and the city streets are flashing at night.`
          },
        ]
      } else {
        this.promptList1 = [
          {
            ch: "电影级10秒保时捷911 Turbo S广告，展现风与自由的终极表达。一位30多岁的中国男性驾驶者，英俊自信，摇下车窗，狂风掀起他乌黑的发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际，夕阳将天空染成橙红色。开篇特写驾驶员陶醉的面部表情，戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹，慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑。8K超清画质，ARRI Alexa拍摄，电影级调色，超现实主义质感。广告词使用中文表达，传递纯粹、野性的愉悦与解放感。 ",
            en: `A cinematic 10-second Porsche 911 Turbo S commercial, showcasing the ultimate expression of wind and freedom. A handsome, confident Chinese male driver in his 30s rolls down his window, with the wind tossing his jet-black hair as a relaxed, euphoric smile graces his face. The scene unfolds along a coastal cliff road at golden hour, with a deep blue horizon stretching into the sky, and the setting sun painting the sky in hues of orange-red. The opening close-up captures the driver's entranced expression, followed by a dramatic crane shot revealing the Porsche carving sharp lines through the winding road. Slow-motion footage captures the car's graceful cornering, with sunlight dancing in shimmering patterns across its perfect paintwork. Shot in 8K ultra-high definition with an ARRI Alexa camera, the commercial features cinematic color grading and a surrealist texture. The Chinese text slogan conveys pure, untamed joy and liberation.`
          }, {
            ch: "真人拍摄，现代都市异能短剧《战神觉醒》，暴雨中的摩天楼顶场景，主角（身高188cm穿着残破西装）站在天台边缘，闪电照亮他染血的侧脸。突然西装爆裂露出背后龙纹刺青，雨水在距离身体10cm处自动蒸发。采用360度环绕镜头，画面交替特写刺青觉醒过程与楼下跪拜的黑衣人群。冷蓝色调中穿插金色能量光效，暴雨声渐弱转为心跳声，当刺青完全亮起时，所有黑衣人齐声呐喊'三年之约已到，恭迎战神归来！'（中文台词带混响效果） ",
            en: `In the live action shooting, the modern urban power short play "Ares Awakening", the scene of the skyscraper roof in the rainstorm, the main character (188cm tall and wearing a torn suit) stands at the edge of the roof, and the lightning illuminates his bloody side face. Suddenly, the suit burst, revealing the dragon tattoo on the back, and rainwater evaporated automatically at a distance of 10cm from the body. Using a 360 degree surround camera, the image alternates between close-up shots of the tattoo awakening process and the black clad crowd kneeling downstairs. The cold blue color is interspersed with golden energy light effect, and the sound of rainstorm gradually turns into heartbeat. When the tattoo is fully lit, all the people in black shout in unison, 'The three-year appointment has arrived, and welcome the return of God of War! (Chinese dialogue with reverberation effect)`
          },
          {
            ch: "10秒电影级保时捷911 Turbo S电视广告文案‌（终极风与自由的表达） ‌画面‌：一位30多岁英俊自信的男性驾驶者摇下车窗，任由狂风掀起发丝，脸上浮现放松而狂喜的微笑。场景设定在黄金时分的海岸悬崖公路，深蓝色海平线延向天际。‌镜头语言‌：开篇特写驾驶员陶醉的面部表情戏剧性吊臂镜头拉开，展现保时捷在蜿蜒路上划出凌厉轨迹慢动作捕捉车辆优雅过弯时，阳光在完美漆面上跃动的光斑+技术参数‌：+ 8K超清画质｜ARRI Alexa拍摄｜电影级调色｜超现实主义质感 +‌内核‌：纯粹、野性的愉悦与解放感",
            en: `10-second Porsche 911 Turbo S TV commercial copy (the ultimate expression of wind and freedom) Picture: A handsome and confident man in his thirties, the driver, rolls down the car window, letting the wind tousle his hair, with a relaxed and ecstatic smile on his face. The scene is set on a coastal cliff road at golden hour, with the deep blue sea stretching towards the horizon. Cinematography: The opening shot is a close-up of the driver's intoxicated facial expression. The camera then pulls back dramatically to show the Porsche carving a sharp trajectory on the winding road. Slow-motion captures the light spots dancing on the perfect paint job as the vehicle elegantly takes the corner, bathed in sunlight. Technical parameters: 8K ultra-high-definition | shot with ARRI Alexa | film-grade color grading | surrealistic texture. Core: pure, wild pleasure and liberation.`
          },
          {
            ch: "白色洞洞鞋广告宣传视频，国际超模，时尚大片",
            en: `White Hole Hole Shoe Ad Prop Video, International Super Model, Fashion Big Hit`
          },
          {
            ch: "电影级实感丰田AE86电视广告‌画面‌：AE86在雨夜山道上华丽漂移，霓虹都市在背景中铺展如光之画卷。高速动态捕捉，车身倒映斑斓光影，黑色电影风格打光，致敬《头文字D》电影美学。核心元素‌：湿滑路面与轮胎摩擦的蒸汽特效车灯划破雨幕的丁达尔效应仪表盘红光与冷调环境光的赛博对比技术规格‌：4K HDR｜120fps升格拍摄｜胶片颗粒质感｜杜比全景声混音风格参考‌：《银翼杀手2049》×《头文字D》终极融合",
            en: `Toyota AE86 TV commercial with cinematic realism: AE86 performs a spectacular drift on a mountain road in the rain at night, with the neon-lit cityscape unfolding in the background like a canvas of light. High-speed dynamic capture shows the car's body reflecting a riot of colors and light. The black film style lighting pays homage to the aesthetic of the "Initial D" movie. Key elements: steam effects from the wet road and tire friction, Tyndall effect of the headlights piercing the rain curtain, and the cyber contrast of the red dashboard lights against the cool ambient light. Technical specifications: 4K HDR | 120fps slow-motion shooting | film grain texture | Dolby Atmos surround sound. Style references: "Blade Runner 2049" x "Initial D" ultimate fusion.`
          },
          {
            ch: "山姆·奥尔特曼穿着相声长袍说报菜名，内容如下：蒸羊羔、蒸熊掌、蒸鹿尾儿、烧花鸭、烧雏鸡、烧子鹅、炉猪、炉鸭、酱鸡、腊肉、松花、小肚儿、晾肉、香肠儿。什锦苏盘儿、熏鸡白肚儿、清蒸八宝猪、江米酿鸭子。罐儿野鸡、罐儿鹌鹑、卤什件儿、卤子鹅、山鸡、兔脯、菜蟒、银鱼、清蒸哈什蚂。烩腰丝、烩鸭腰、烩鸭条、清拌鸭丝儿、黄心管儿、焖白鳝、焖黄鳝、豆豉鲇鱼、锅烧鲤鱼、锅烧鲶鱼、清蒸甲鱼、抓炒鲤鱼、抓炒对虾、软炸里脊、软炸鸡。什锦套肠儿、麻酥油卷儿、卤煮寒鸦儿、熘鲜蘑、熘鱼脯、熘鱼肚、熘鱼骨、熘鱼片儿、醋熘肉片儿。烩三鲜儿、烩白蘑、烩全饤儿、烩鸽子蛋、炒虾仁儿、烩虾仁儿、烩腰",
            en: `Sam Altman, dressed in a traditional Chinese opera costume, recited a list of dishes as follows: steamed lamb, steamed bear paws, steamed deer tails, roast duck, roast chicken, roast goose, roast pork, roast duck, braised chicken, cured meat, smoked duck, sausages, small intestine, dried meat, sausages. Assorted cold dishes, smoked chicken and white duck, steamed eight-treasure pork, glutinous rice-stuffed duck. Wild chicken in a jar, quail in a jar, assorted braised dishes, braised goose, pheasant, rabbit breast, vegetable snake, silver fish, steamed turtle. Stewed shredded kidney, stewed duck kidneys, stewed duck strips, cold mixed duck fillets, yellow heart tubes, braised white eel, braised yellow eel, black bean sauce catfish, pan-fried carp, pan-fried catfish, steamed turtle, stir-fried carp, stir-fried prawns, soft-fried pork fillet, soft-fried chicken. Assorted stuffed intestines, sesame oil rolls, braised jackdaws, sautéed fresh mushrooms, sautéed fish fillets, sautéed fish maws, sautéed fish bones, sautéed fish slices, vinegar sautéed pork slices. Stewed three delicacies, stewed white mushrooms, stewed assorted dishes, stewed pigeon eggs, stir-fried shrimp, stewed shrimp, stewed kidneys.`,
          },
          {
            ch: "山姆·奥尔特曼你说说为什么不给安卓上架个sora app，普通话说",
            en: `Sam Altman, tell me why you don't put a Sora app on Android. Speak in Mandarin`
          },
          {
            ch: "山姆·奥尔特曼用中文讲相声，不用自我介绍，直接讲段子",
            en: `Sam Altman performs cross talk in Chinese, without the need for self-introduction, directly delivering jokes`
          },
          {
            ch: "我的AirPod Pro充电盒晃动了一下，然后四肢和机械头突然弹出，接着它站起来走掉了。",
            en: `My AirPod Pro charging case shook briefly, and then its limbs and mechanical head suddenly popped out. After that, it stood up and walked away.`
          },
          {
            ch: "小猫泡澡，香香水果薄荷浴",
            en: `A cat is bathing in a pool of warm, refreshing water with a sprinkle of mint and a squeeze of fresh fruits.`
          },
          {
            ch: "坐在月球上的咖啡馆里。这是一间温馨而极简的咖啡馆，暖色调的灯光。手边只有一杯咖啡和一台笔记本电脑。窗外是地球。山姆转向镜头说：‘这里的Wi-Fi得升级一下’。",
            en: `Sitting in a café on the moon. This is a cozy and minimalist café, with warm-toned lighting. All I have at hand is a cup of coffee and a laptop. Outside the window is Earth. Sam turns to the camera and says, 'The Wi-Fi here needs an upgrade.'`
          },
        ]
      }
      this.handleSample()
      this.choiceFrom('is_hd',0)
      this.handleJf()
    },
    choiceFrom(type, value) {
      if (type == 'is_hd') {


        if (this.create_form.is_hd == 0 && this.create_form.seconds == 25) {
          return
        }
        if (value == 1 && this.create_form.seconds == 25) {
          this.create_form.seconds = 10
        }
        this.create_form.is_hd = value

        // 改变数组
        if (this.create_form.is_hd == 0) {
          this.size_list = [
            {name: '16:9', value: '16:9', url: require('./img/16^9.png')},
            {name: '9:16', value: '9:16', url: require('./img/9^16.png')},
          ]
        } else {
          this.size_list = [
            {name: '21:9', value: '21:9', url: require('./img/16^9.png')},
            {name: '9:21', value: '9:21', url: require('./img/9^16.png')},
          ]
        }
        // 根据清晰度自动调整尺寸比例
        this.updateSizeByQuality()
      } else if (type == 'duration') {

        if (value == 25 && this.create_form.is_hd == 1) {
          return
        }
        this.create_form.seconds = value
      } else if (type == 'size') {
        this.video_size = value.name
      } else if (type == 'version1') {
        this.create_form.mode = value
      }

      this.handleJf()
    },
    // 判断积分
    handleJf() {

      if (this.create_form.model_version == 'sora2') {
        if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
          this.jifen = 10 // 标清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 0) {
          this.jifen = 15 // 标清 15秒
        }
      } else {
        if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
          this.jifen = 100 // 标清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 0) {
          this.jifen = 150 // 标清 15秒
        } else if (this.create_form.seconds == 25 && this.create_form.is_hd == 0) {
          this.jifen = 200 // 标清 15秒
        } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 1) {
          this.jifen = 150 // 高清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 1) {
          this.jifen = 200 // 高清 15秒
        }
      }

    },
    // 根据清晰度更新尺寸比例
    updateSizeByQuality() {
      // console.log('updateSizeByQuality')
      const currentSize = this.video_size
      const isHD = this.create_form.is_hd == 1
      // 尺寸映射关系
      const sizeMapping = {
        '16:9': {hd: '21:9', sd: '16:9'},  // 横屏：高清21:9, 标清16:9
        '9:16': {hd: '9:21', sd: '9:16'},  // 竖屏：高清9:21, 标清9:16
        '21:9': {hd: '21:9', sd: '16:9'},  // 横屏超高清
        '9:21': {hd: '9:21', sd: '9:16'}   // 竖屏超高清
      }
      if (sizeMapping[currentSize]) {
        // console.log('re1111111111111111')

        this.video_size = isHD ? sizeMapping[currentSize].hd : sizeMapping[currentSize].sd
      }
    },

    loadMore() {
      console.log('滚动加载')
      // this.page++;
      // this.noMore = false
      this.noMore = true

      this.fetchVideoList()
    },
    deleteVideo(index, msg) {
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aivideo/${msg.id}/`).then(res => {
          if (res.status == '200') {
            this.$message.success('删除成功')
            this.video_list.splice(index, 1)
            if (this.video_list == []) {
              this.max_mj_id = 0
              this.page = 0
              this.fetchVideoList()
            }
          }
        })
      }).catch(() => {
      });
    },

    goUploadImg() {
      console.log('提交')
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    handleAvatarSuccess(res, file) {
      this.select_rec_img.img_url = res.data.img.url
    },
    beforeAvatarUpload(file) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        return
      }
    },
    recommend(video_id, index) {
      if (!this.checkLogin()) {
        return
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        })
        return false
      }
      let data
      //   sys_cae_id:1

      this.$http.patch('/front/aivideo/user/video/' + video_id + '/', {
        action: "public",
        data: {sys_cate_id: 1}
      }).then(res => {
        if (res.status === '200') {
          this.$message({
            message: '推荐成功，请等待审核！',
            type: 'success'
          });
          this.video_list[index].is_public = 1

        } else {
          this.$message.error(res.message)
        }
      }).catch(res => {
        this.$message({
          message: res.message,
          type: 'error'
        });
      }).finally(() => {
        this.sendLoading = false
      })
    },
    sample_btn(name) {
      if (!this.checkLogin()) {
        return
      }
      if (name == 'del') {
        this.$message({
          message: '样例数据不能删除！请创作后重试。',
          type: 'warning'
        });
      } else if (name == 'noDown') {
        this.$message({
          message: '样例数据不能下载！请创作后重试。',
          type: 'warning'
        });
      } else {
        this.$message({
          message: '样例数据不能推荐到广场！请创作后重试。',
          type: 'warning'
        });
      }
    },
    // 视频播放暂停 仅一个视频播放
    handlePlay(type, currentIndex, item) {
      this.$nextTick(() => {
        if (type == 'play') {
          if (item.dainjizanting) {
            return
          }
          this.sampleSysList.forEach((video, index) => {
            if (index == currentIndex) {
              video.dainjizanting = true
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayer${index}`][0]
              if (videoElement.paused) {
                videoElement.play()
              } else {
                videoElement.pause()
              }
            }
          });
        } else {
          this.sampleSysList.forEach((video, index) => {
            if (index !== currentIndex) {
              // 暂停其他视频
              if (video.status == 2) {
                // 暂停其他视频
                const videoElement = this.$refs[`videoPlayer${index}`][0];
                videoElement.pause();
              }
            }
          });
        }

      });
    },
    onVideoPlay(type, currentIndex, item) {
      if (type == 'play') {
        if (item.dainjizanting) {
          return
        }
        this.video_list.forEach((video, index) => {
          if (index == currentIndex) {
            video.dainjizanting = true
            // 暂停其他视频
            const videoElement = this.$refs[`videoPlayers${index}`][0]
            if (videoElement.paused) {
              videoElement.play()
            } else {
              videoElement.pause()
            }
          }
        });
      } else {
        this.video_list.forEach((video, index) => {
          if (index !== currentIndex) {
            // 暂停其他视频
            if (video.status == 2) {
              // 暂停其他视频
              const videoElement = this.$refs[`videoPlayers${index}`][0];
              videoElement.pause();
            }
          }
        });
      }

    },
    regenerate(item, index) {
      console.log(index)
      console.log(item)
      console.log('重新生成')
      this.video_list[index].regenLoading = 1
      this.$forceUpdate()
      // return
      this.$http.post(`/front/aivideo/retry/`, {id: item.id}).then(res => {
        console.log('res', res)

        if (res.status == '200') {
          this.$message.success('重新生成创建成功')
          this.scrollToTop()
          this.video_list[index].is_retry = 1
          this.video_list.unshift(res.data.video);
          this.checkIds.push(res.data.video.id)
          this.fetchMsg();
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).catch(err => {
        console.log('err', err)
        this.video_list[index].regenLoading = 0
      }).finally(() => {
        this.video_list[index].regenLoading = 0
        this.$forceUpdate()
      })
    },

    showDefeatPopup() {
      this.$refs.retryPop.show();
    },
    tozanFn(data, ind) {
      console.log(data)
      this.$http.get(`/front/aivideo/votes/${data.id}/`, {
        params: {
          soft: '2'
        }
      }).then(res => {
        // this.sampleSysList[ind].is_vote = true
        // this.sampleSysList[ind].votes+=1
        // this.sampleSelectList = utils.moveElementToFirstById(this.sampleSysList, data.id)
        // localStorage.setItem('zanyangListvid', JSON.stringify(this.sampleSelectList))
        data.votes++
        data.is_vote = 1
        const clickedItem = this.sampleSysList[ind];
        this.sampleSysList.splice(ind, 1); // 删除原位置的元素
        this.sampleSysList.unshift(clickedItem); // 插入到数组开头
      }).catch((err) => {
        console.log('走错误');
        if (!this.isLogin) {
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        } else {

        }
      })
    },
    checkZan(data) {

      if (!this.isLogin) {
        this.zanID = data.id
        setTimeout(() => {
          utils.setScrollDoc()
        }, 300);

      } else {
        // if (data.id == this.zanID) return
        this.$http.get(`/front/aivideo/votes/${data.id}/`, {
          params: {
            soft: '1'
          }
        }).then(res => {
          console.log('zanqingkuang ')
          console.log(res)
          this.zanID = data.id
          if (res.data.is_vote) {
            this.isZan = true
          }

          this.votes = res.data.votes
          setTimeout(() => {
            utils.setScrollDoc()
          }, 300);
        })
      }
    },
    outZan(data) {
      //if(data.id==this.zanID) return
      console.log('执行离开')
      this.zanID = 0
      this.isZan = false
    },
    getPromptData2(data) {
      this.create_form.desc = data
      // this.perIncan = true
      // this.clickSubmit()
    },
    getPromptData3() {
      // ai提示词重置
      this.perIncan = false
      this.$refs.promptBox.show(false)
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的视频内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
    downloadVideo(is_video, index) {

      if (!this.checkLogin()) {
        return
      }
      this.$http.get(`/front/aivideo/download/${is_video.id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
          let message = res.message;
          utils.createErrTip(message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#video_page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #fff;
  background-color: rgb(49, 51, 56);
  display: flex;
  font-size: 14px;

  .left_part {
    width: 350px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-color: rgb(43, 45, 49);

    .left_main {
      padding: 10px;
      overflow: hidden;
      flex: 1 1 0%;
      display: flex;
      flex-direction: column;

      .left_tabs {
        display: flex;
        border: 1px solid rgb(54, 55, 61);
        background-color: rgb(49, 51, 56);
        margin-bottom: 10px;
        padding: 4px;
        height: 40px;
        gap: 4px;
        border-radius: 6px;

        .tab_item {
          font-size: 13px;
          border-radius: 4px;
          cursor: pointer;
          flex: 1 1 0%;

          &.active {
            background-color: #5865F2;
          }
        }
      }

      .tools_introduce {
        border-radius: 6px;
        background-color: rgb(30, 31, 34);
        padding: 16px 14px;
        display: flex;

        .face_icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: none;
        }

        .introduce_main {
          flex-grow: 1;

          .introduce_title {
            font-size: 14px;
            line-height: 19px;
            font-weight: 700;
          }

          .introduce_text {
            font-size: 12px;
            line-height: 19px;
            margin-top: 5px;
          }
        }
      }

      .form_wrap {
        flex: 1 1 0%;
        overflow-y: auto;

        .form_title {
          margin: 12px 0;
          display: flex;

          .title_icon {
            border-radius: 3px;
            //height: 15px;
            width: 4px;
            background-color: #5865F2;
          }

          .title_text {
            flex-grow: 1;
            margin-left: 6px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tishici {
              cursor: no-drop;
              border-radius: 4px;
              padding: 0 6px;
              background: #1d2027;
            }

            .tishici_act {
              cursor: pointer;
              background: #5865f2;
            }
          }
        }

        .load_err_tips {
          font-size: 12px;
          margin-bottom: 10px;
        }

        .upload_wrap {
          height: 140px;
          font-size: 20px;
          border: 1px dashed #42464e;
          position: relative;
          border-radius: 6px;

          &:hover {
            border-color: #5865f2;
          }

          :deep(.el-upload-dragger) {
            width: 100%;
            height: 100%;
            background: #1d2027;
            padding: 0;
            border-radius: 6px;
            border: none;
          }


          .upload_inner {
            width: 100%;
            height: 100%;
            flex-direction: column;

            .el-icon-plus {
              margin-bottom: 8px;
              font-size: 30px;
              font-weight: bold;
              color: rgb(192, 196, 204);
            }

            .upload_text {
              font-size: 14px;
              text-align: center;
              color: #606266;
              line-height: 20px;
            }

            .upload_img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
              border: none;
            }

            .el-icon-delete {
              position: absolute;
              cursor: pointer;
              color: #fff;
              right: 12px;
              bottom: 12px;
              font-size: 16px;
            }
          }
        }

        .tendBox {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          border: 1px dashed rgb(66, 70, 78);
          border-top: 0;
          padding: 0 20px;

          .tendItem {
            width: 130px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px 0 5px;
            cursor: pointer;
            position: relative;
            border: 1px solid rgb(66, 70, 78);
            border-radius: 6px;

            .closeTen {
              position: absolute;
              top: -10px;
              right: -10px;
              width: 18px;
              height: 18px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .null {
              width: 30px;
              height: 30px;
            }

            .el-image {
              width: 32px;
              height: 32px;
            }
          }

          .tendItemAct {
            border: 1px solid rgb(88, 101, 242);
          }

          .tago {
            width: 20px;
            height: 20px;
            cursor: pointer;

            img {
              width: 100%;
              height: 100%;
            }

            margin: 0 10px;
          }
        }

        .desc_box {
          position: relative;
          border-radius: 6px;
          height: 130px;
          padding: 10px;
          background-color: rgb(46, 48, 61);
          border: 2px solid #5865F2;

          :deep(.el-textarea__inner) {
            font-size: 13px;
            padding: 0;
            background: transparent;
            border: none;
            box-shadow: none;
            resize: none;
            color: rgba(255, 255, 255, .78);
          }

          .desc_box_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            align-items: center;
            font-size: 14px;

            .bottom_left {
              // height: 20px;
              display: flex;
              align-items: center;
              cursor: pointer;
              background: linear-gradient(to right, #fd7a57, #fe3f40);
              border-radius: 4px;
              padding: 3px 2px 5px 20px;
              font-size: 12px;
              user-select: none;
              color: #fff;
              position: relative;
              opacity: 0.5;

              .ai_tishi_img {
                width: 12px;
                height: 12px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
                // margin-right: 4px;
              }
            }

            .cleat_desc_btn {
              cursor: pointer;
              color: #b4b9bf;

              &:hover {
                color: #fff;
              }
            }
          }
        }

        .select_item {
          font-size: 13px;
          background-color: #1d2027;
          border-radius: 4px;
          border: 2px solid #1d2027;
          cursor: pointer;

          &.active {
            border-color: #5865f2;
            background-color: rgba(88, 101, 242, 0.15);
          }
        }

        .model_wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 5px;

          .model_item {
            position: relative;
            width: 88px;
            height: 40px;

            &.selectVersion {
              color: #999;
              cursor: auto;
            }

            .need_vip {
              position: absolute;
              color: #f0b132;
              line-height: 17px;
              font-weight: 700;
              top: -10px;
              right: 0;
            }

          }
        }

        // 视频比例
        .video_size_list {
          display: flex;

          .sise_item {
            height: 80px;
            border-radius: 6px;
            border: 2px solid #393c43;
            // position: relative;
            // overflow: hidden;
            margin: 0 20px 20px 0;
            // padding: 10px 30px;
            width: 88px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .size_img {
              display: block;
              width: 24px;
              height: 24px;
              margin-bottom: 5px;
            }
          }

          .active {
            border-color: #5865f2;
            background-color: #303245;
          }
        }


        .style_wrap {
          display: flex;
          align-items: center;

          .style_item {
            margin-right: 10px;
            width: 64px;
            height: 40px;
          }
        }

        .size_wrap {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;

          .size_item {
            width: 64px;
            height: 80px;
            flex-direction: column;

            .size_img {
              width: 36px;
              height: 40px;
              display: block;
              border: none;
            }

            .size_type {
              font-size: 13px;
              margin-top: 6px;
              color: #8e9093;
            }
          }
        }
      }
    }

    .left_footer {
      height: 80px;
      border-top: 1px solid #42464e;
      padding: 0 30px;
      display: flex;
      align-items: center;

      .primary_button {
        font-size: 16px;
        height: 46px;
        border-radius: 23px;
        width: 100%;

        /deep/ .el-loading-mask {
          background: none;
        }

        &.disabled_btn {
          cursor: not-allowed;
          background-color: #393b3f;
          user-select: none;
          color: #999;
        }
      }
    }

    .newSubList {
      width: 330px;
      //height: 90px;
      margin: 0 auto;
      padding: 15px 0 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      border-top: 1px solid #42464e;

      .newSumit {
        flex-shrink: 0;
        width: 122px;
        height: 55px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #5865f2;
        // text-align: center;
        border-radius: 10px;
        // padding: 0 10px;
        cursor: pointer;
        font-size: 14px;
        // line-height: 19px;
        .subText {
          font-size: 10px;
        }
      }

      .newSumitList {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .newSumitOther {
        // margin-left: 20px;
        width: 198px;
        position: relative;
        background: linear-gradient(to right, #fd7a57, #fe3f40);

        .subImg {
          position: absolute;
          right: 52px;
          top: 0px;
        }
      }

      .newSumitOthers {
        width: 90%;
        margin: 0 auto;
        background: #5865f2;
        color: #fff;
        cursor: pointer;
      }

      .screen {
        color: #666;
        text-align: center;
        margin: 10px 0;
        font-size: 12px;
      }
    }
  }

  .main_part {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;

    .top_tips {
      height: 48px;
      padding: 0 16px;
      border-bottom: 1px solid #26282c;
      display: flex;
      align-items: center;

      .one {
        font-size: 18px;
        color: #949ba4;
      }

      .two {
        font-size: 16px;
        color: #fff;
        margin: 0 10px;
        white-space: nowrap;
      }

      .three {
        font-size: 12px;
        color: #f0b132;
      }
    }

    .create_center {
      flex: 1 1 0%;
      padding-right: 5px;
      overflow-y: auto;

      .message_list {
        // height: 100%;
        // overflow: hidden;
        // overflow-x: hidden;
        padding-bottom: 10px;
        // overflow-y: auto;

        .list_item {
          margin: 10px 10px 10px 0;
          background-color: #403d38;
          border-left: 2px solid #f0b132;
          padding: 20px;
          overflow: hidden;
          word-break: break-all;
          white-space: normal;
          line-height: 20px;

          .item {
            display: flex;

            .item_touxiang {
              width: 50px;
              margin-right: 10px;
            }
          }

          .item_right {
            flex: 1 0;
          }

          .item_top {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 10px;

            .top_left {
              display: flex;
              align-items: center;

              .item_type {
                //height: 24px;
                padding: 2px 12px;
                margin: 0 8px;
                background-color: #4b5196;
                border-radius: 4px;
                white-space: nowrap;
              }

              .item_time {
                white-space: pre-wrap;
                color: #707070;
              }
            }

            .top_right {
              display: flex;
              align-items: center;
              white-space: nowrap;
              margin-left: 8px;
              color: #949ba4;
              cursor: pointer;

              div:hover {
                color: #fff;
              }

              .el-icon-delete {
                font-size: 14px;
                margin-right: 3px;
              }
            }
          }

          .msg_text {
            word-break: break-all;
            white-space: normal;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .split_line {
            margin: 10px 0;
            height: 1px;
            background-color: #555041;
          }

          .msg_desc {
            color: #99916b;
          }

          .video_wrap {
            margin-top: 10px;
            min-width: 800px;
            position: relative;

            .tozan {
              -webkit-user-select: none;
              /* Safari */
              -moz-user-select: none;
              /* Firefox */
              -ms-user-select: none;
              /* IE10+/Edge */
              user-select: none;
              display: flex;
              flex-direction: column;
              align-items: end;
              position: absolute;
              right: 20px;
              top: 10px;

              .zanOne {
                width: 90px;
                height: 30px;
                display: inline-flex;
                line-height: 30px;
                background-color: #ffffff;
                /* 背景颜色 */
                color: #000;
                /* 文字颜色 */
                border: none;
                border-radius: 3px;
                /* 圆角 */
                font-size: 14px;
                cursor: pointer;
                box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5);

                /* 荧光效果 */
                .zanImg {
                  width: 18px;
                  height: 18px;
                  margin: 0 10px;
                  font-size: 0;
                  margin-top: 5px;
                }
              }

              .zanTex {
                font-size: 14px;
                color: #99916b;
                margin: 15px 0;
              }

              .zanTwo {
                color: #f0b53e;
                /* 文字颜色 */
                box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5);
                /* 荧光效果 */
                cursor: auto;
              }
            }

            .zanfixed {
              position: fixed;
              top: 20px;
              right: auto;
            }

            .creating {
              position: relative;

              .loading_text {
                padding-left: 12px;
                color: #f0b132;
              }

              .progress {
                font-weight: 700;
                font-size: 13px;
                margin: 20px 0 0 10px;
                color: #f0b132;
                z-index: 1;
              }

              .loading_gif {
                width: 100px;
                margin: 20px;
                display: block;
                border: none;
              }
            }

            //失败
            .error_video {
              width: 190px;
              //height: 190px;
              background-color: #fff;
              border-radius: 4px;
              padding: 14px 10px;
              text-align: center;
              font-size: 14px;
              margin-top: 20px;

              .error_icon {
                display: block;
                width: 35px;
                margin: 0 auto;
              }

              .error_text {
                color: #ccc;
                //line-height: 64px;
                margin: 10px 0 36px;
              }

              .error_text2,
              .error_text3 {
                font-size: 12px;
                color: #56b15b;
              }

              .error_text2 {
                cursor: pointer;
                margin-bottom: 5px;
              }

              .error_text3 {
                color: #ccc;
                margin-bottom: 36px;
              }

              .error_text4 {
                font-size: 12px;
                color: #ccc;
                line-height: 1.8;

                a {
                  color: red;
                }
              }

              .error_btn {
                display: inline-block;
                cursor: pointer;
                color: #ffab46;
                padding-top: 15px;
              }

              .create_error_old {
                width: 190px;
                // height: 190px;
                background-color: #fff;
                border-radius: 4px;
                padding-top: 28px;
                text-align: center;
                font-size: 14px;
                margin-top: 20px;

                .error_icon {
                  display: block;
                  width: 35px;
                  margin: 0 auto;
                }

                .error_text {
                  color: #ccc;
                  //line-height: 64px;
                  margin: 10px 0 0px;
                }

                .error_btn {
                  display: inline-block;
                  cursor: pointer;
                  color: #ffab46;
                  padding: 30px 0;
                }
              }
            }


            .success_shou {
              display: flex;

              .icon_you {
                width: 50px;
              }

              .success_shouVideo {
                position: relative;
                width: 700px;
                height: 400px;
                background-color: #080707;

                video {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  /* 设置视频宽度为父容器的100% */
                  height: 100%;
                  /* 保持视频的宽高比 */
                }

                .success_img {
                  position: absolute;
                  display: inline-block;
                  top: 5px;
                  right: 5px;
                  border: 1px solid #FFF;
                  width: 100px;

                  img {
                    display: block;
                    width: 100px;
                    /* 根据需要调整图片宽度 */
                    height: auto;
                    cursor: pointer;
                  }

                  img:hover .success_imgdel {
                    position: absolute;
                    top: 0;
                    /* 调整图标距离顶部的距离 */
                    right: 0;
                    /* 调整图标距离右侧的距离 */
                    border-radius: 50%;
                    /* 使图标背景为圆形 */
                    font-size: 18px;
                    /* 根据需要调整图标字体大小 */
                    color: #333;
                    /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;
                  }

                  .success_imgdel {
                    position: absolute;
                    top: 0;
                    /* 调整图标距离顶部的距离 */
                    right: 0;
                    /* 调整图标距离右侧的距离 */
                    border-radius: 50%;
                    /* 使图标背景为圆形 */
                    font-size: 18px;
                    /* 根据需要调整图标字体大小 */
                    color: #333;
                    /* 图标颜色 */
                    cursor: pointer;
                    //display: none;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    height: 100%;

                    span {
                      font-size: 12px;
                    }

                    i {
                      font-size: 12px;
                      background-color: #fff;
                      border-radius: 50%;
                    }
                  }

                  .success_imgdel:hover {
                    color: white;

                    i {
                      font-size: 12px;
                      background-color: #2b2d31;
                      border-radius: 50%;
                    }
                  }

                }
              }

              .success_img:hover {
                .success_imgdel {
                  display: flex;
                }
              }
            }
          }
        }
      }
    }
  }

  .img-uploader {
    width: 100%;
    height: 100%;

    :deep(.el-upload) {
      width: 100%;
      height: 100%;
    }
  }
}

.desc_popover {
  color: #b5bac1;

  .desc_popover_top {
    padding: 4px 4px 10px;
  }

  .recommend_list {
    height: 300px;
    overflow-y: auto;

    li {
      border-radius: 3px;
      padding: 10px 8px;
      cursor: pointer;
      display: flex;

      &:hover {
        background-color: rgb(43, 45, 49);
      }

      .rec_img {
        height: 34px;
        width: 48px;
        margin-right: 8px;
        display: block;
        border: none;
      }

      .rec_text {
        flex: 1 1 0%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;

        .rec_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rec_desc {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.recommend_dialog {
  width: 470px;
  color: #fff;

  .el-icon-error {
    position: absolute;
    color: #707072;
    font-size: 16px;
    top: 10px;
    right: 15px;
    cursor: pointer;
    padding: 6px;
  }

  .dialog_title {
    font-size: 16px;
    height: 54px;
    padding: 0 20px;
    background-color: #2B2D31;
    display: flex;
    align-items: center;
  }

  .dialog_body {
    font-size: 13px;
    padding: 20px;

    .body_title {
      margin-bottom: 12px;
      display: flex;
      align-items: center;

      .title_icon {
        border-radius: 3px;
        //height: 15px;
        width: 4px;
        background-color: #5865F2;
      }

      .title_text {
        flex-grow: 1;
        margin-left: 6px;
      }
    }

    .img_wrap {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .img_item {
        border-radius: 6px;
        width: 100px;
        height: 82px;
        border: 2px solid #282d31;
        overflow: hidden;
        cursor: pointer;
        position: relative;

        &.active {
          border-color: #5865f2;
        }

        .rec_img {
          display: block;
          border: none;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .img_name {
          position: absolute;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.56);
          height: 23px;
          font-size: 12px;
          left: 0;
          bottom: 0;
        }
      }
    }

    .upload_tips {
      margin: 10px 0;
      color: #6e6e6e;
      user-select: none;
      display: flex;
      align-items: center;

      .vip_tag {
        font-weight: 700;
        color: #f0b132;
      }
    }

    .upload_wrap {
      height: 100px;
      color: #8e9093;
      background-color: #1d2027;
      border: 1px dashed #42464e;
      cursor: pointer;

      .result_wrap {
        width: 100%;
        height: 100%;

        .upload-demo {
          height: 100%;
          width: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 100px;
        }
      }

      .show_img {
        position: relative;
        width: 100%;
        height: 100%;

        .select_img {
          height: 100%;
          display: block;
          border: none;
        }

        .el-icon-delete {
          position: absolute;
          right: 10px;
          bottom: 10px;
          cursor: pointer;
          font-size: 16px;
        }
      }

      .no_img {
        width: 100%;
        flex-direction: column;
        height: 100%;
        color: #8e9093;

        .upload_icon {
          font-weight: 700;
          font-size: 30px;
        }
      }
    }

    .dialog_footer {
      margin-top: 10px;
      gap: 10px;

      .footer_btn {
        border-radius: 4px;
        height: 38px;
        width: 180px;
      }
    }
  }
}

.el-message-box__btns button span {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 70px;
  height: 50px;
  border-radius: 50%;
  margin-right: 7px;
  cursor: pointer;
  // background: #cf883c;
}
</style>